module.exports = __webpack_public_path__ + "img/question_top_bg.be291409.png";